import { render, staticRenderFns } from "./BulkProfileList.vue?vue&type=template&id=398c5c86&scoped=true"
import script from "./BulkProfileList.vue?vue&type=script&lang=ts"
export * from "./BulkProfileList.vue?vue&type=script&lang=ts"
import style0 from "./BulkProfileList.vue?vue&type=style&index=0&id=398c5c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c5c86",
  null
  
)

export default component.exports